/**
 * fixed is different from sticky.
 * - fixed will put an element position fixed based on its original position.
 * - sticky will put an element fixed based on the user's actions
 *
 * sticky creates the document on scroll listener and sets elements sticky depending on its settings.
 *
 * - data-sticky-container: String      (Element to sticky the element inside of, ie '#element' or '.element')
 * - data-sticky-position-top: String   (Margins to the top of the window when stickied.)
 *
 * used in vue apps with the additional v-sticky attribute which trigger initSticky on every view update.
 */

function sticky() {
	const stickySelector = '.js-sticky';

	if ($(stickySelector).length == 0) {
		window.initSticky = function() {
			console.log('NO STICKY CLASS FOUND');
		};
		return;
	}

	/* Please only do one js-sticky per page till we got it figured out better for extra elements. */

	let $sticky = $(stickySelector);
	let $container = $($sticky.data('sticky-container'));
	let containerStart = $container.offset().top;
	let containerEnd = containerStart + $container.height() - $sticky.height();
	let top = $sticky.data('sticky-position-top');
	let left = $sticky.offset().left;
	let width = $sticky.parent().width();
	let isStickyTop = false;
	let isStickyBottom = false;

	function setStickyVars() {
		$sticky = $(stickySelector);
		$container = $($sticky.data('sticky-container'));
		containerStart = $container.offset().top;
		containerEnd = containerStart + $container.height() - $sticky.height();
		top = $sticky.data('sticky-position-top');
		left = $sticky.offset().left;
		width = $sticky.parent().width();
	}

	function setStickyTop() {
		if (isStickyTop) {
			return;
		}
		isStickyTop = true;
		isStickyBottom = false;
		$sticky.css({
			position: 'fixed',
			top: top,
			left: left == 0 ? '' : left,
			width: width
		});
	}

	function setStickyBottom() {
		if (isStickyBottom) {
			return;
		}
		isStickyTop = false;
		isStickyBottom = true;
		$sticky.css({
			position: 'fixed',
			top: containerEnd,
			left: left == 0 ? '' : left,
			width: width
		});
	}

	function unsetSticky() {
		if (!isStickyTop && !isStickyBottom) {
			return;
		}
		isStickyTop = false;
		isStickyBottom = false;
		$sticky.css({
			position: '',
			top: '',
			left: '',
			width: ''
		});
	}

	/*
	 * checkStickyStatus
	 *
	 * if the element is inside of the container
	 *    if the element 
	 *    where sticky means: use the top+margin and left coordinates and set position fixed.
	 * if the element goes outside of the container, remove the style
	 */
	function checkStickyStatus(ev) {
		const windowPositionFromTop = window.pageYOffset;
		const windowHeight = window.innerHeight;

		if (windowPositionFromTop >= containerStart && windowPositionFromTop <= containerEnd) {
			setStickyTop();
		} else if (windowPositionFromTop >= containerStart && windowPositionFromTop > containerEnd) {
			setStickyBottom();
		} else {
			unsetSticky();
		}
	}

	/* initSticky is called whenever the page is updated */
	window.initSticky = function() {
		if ($(stickySelector).length == 0) {
			return;
		}

		/* Remove class so we can properly measure stuff */
		$(stickySelector).removeClass('sticky');

		$(stickySelector).addClass('sticky');
		setStickyVars();
		$(document).on('scroll', checkStickyStatus);
	};
	window.initSticky();
}
sticky();
